import React, { Component } from 'react';
import TitlePage from '../../containers/Header/TitlePage';
import NavBar from '../../containers/Header/NavBar';
import { Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setUserDetails } from '../../actions/userDetails';
import './UserDetails.css';

class UserDetails extends Component {
  render() {
    const { setUserDetails } = this.props;
    const { userDetails } = this.props;
    return (
      <div className="user-details-page">
        <TitlePage />
        <NavBar {...this.props} />
        <div className="user-details">
          <h1>User Details</h1>
          <Form>
            <FormGroup>
              <Label for="name">Name</Label>
              <Input
                type="text"
                name="name"
                id="name"
                value={userDetails.name}
                onChange={e => setUserDetails(e.target.value, 'name')}
              />
            </FormGroup>
            <FormGroup>
              <Label for="role">Role</Label>
              <Input
                type="textarea"
                name="role"
                id="role"
                value={userDetails.role}
                onChange={e => setUserDetails(e.target.value, 'role')}
              />
            </FormGroup>
            <FormGroup>
              <Label for="email">Email</Label>
              <Input
                type="email"
                name="email"
                id="email"
                value={userDetails.email}
                onChange={e => setUserDetails(e.target.value, 'email')}
              />
            </FormGroup>
            <FormGroup>
              <Label for="phone">Phone</Label>
              <Input
                type="text"
                name="phone"
                id="phone"
                value={userDetails.phone}
                onChange={e => setUserDetails(e.target.value, 'phone')}
              />
            </FormGroup>
            <FormGroup>
              <Label for="phoneah">After Hours Phone</Label>
              <Input
                type="text"
                name="phoneah"
                id="phoneah"
                value={userDetails.phoneAH}
                onChange={e => setUserDetails(e.target.value, 'phoneAH')}
              />
            </FormGroup>
            <FormGroup>
              <Label for="fax">Fax</Label>
              <Input
                type="text"
                name="fax"
                id="fax"
                value={userDetails.fax}
                onChange={e => setUserDetails(e.target.value, 'fax')}
              />
            </FormGroup>
            <Button
              color="success"
              onClick={() => this.props.history.push('PatientHome')}
              className="question-button"
            >
              Save
            </Button>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userDetails: state.userDetails,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setUserDetails,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserDetails);



// WEBPACK FOOTER //
// ./src/components/UserDetails/UserDetails.js